import LeaveRequestForm from './leave'
import LeaveRequestPreview from './leave-preview'
import CompensateRequestForm from './compensate'
import CompensateRequestPreview from './compensate-preview'
import { DiscardRequest } from './discard-request'
import { ConfirmCancel } from './confirm-cancel'

export {
  LeaveRequestForm,
  LeaveRequestPreview,
  CompensateRequestForm,
  CompensateRequestPreview,
  DiscardRequest,
  ConfirmCancel,
}



// WEBPACK FOOTER //
// ./src/components/my-leave/form/index.js